// extracted by mini-css-extract-plugin
export var assigneeBadge = "_jz-0";
export var assigneeDetails = "_jz-1";
export var assigneeInfo = "_jz-2";
export var dropdownContainer = "_jz-4";
export var dropdownImage = "_jz-5";
export var editAssigneeInfo = "_jz-3";
export var editAssigneeModalContainer = "_jz-6";
export var hidden = "_jz-8";
export var input = "_jz-7";